<!--
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-06-11 11:15:55
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-09-20 11:54:55
 * @FilePath: /lobby/src/components/PaymentMethodForKE.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div
    class="dw_con_ke"
    :style="
      from == 'withdraw'
        ? 'border-radius: 0 0 0.16rem 0.16rem;margin-top: -2%'
        : 'border-radius: 0.16rem 0.16rem 0 0;'
    "
  >
    <ul :style="from == 'withdraw' ? 'border-top-width: 0px;border-bottom-width: 0px;' : ''">
      <div class="dw_title">{{ $t('payment.title') }}</div>
      <div class="dw_Pay">
        <div v-for="(list, i) in methodConfig" :key="i" class="dw_row">
          <div
            v-for="(item, j) in list"
            :key="j"
            :class="`${selectMethod == i * 3 + j ? 'active' : 'un_active'}`"
          >
            <img v-if="item" :src="item.icon" alt="" @click="onSelectMethod(i * 3 + j)" />
            <div v-else class="un_active"></div>
          </div>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/user'
import { mapState } from 'pinia'

export default {
  name: 'LobbypayChannel',
  props: {
    updateData: {
      type: Function,
      default: () => {}
    },
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      app_env: import.meta.env.VITE_APP_ENV,
      selectChannel: 0,
      selectMethod: 0,
      payChannels: [
        {
          text: 'Safaricom',
          value: 'safaricom'
        }
      ],
      selectBankCodeKey: 0,
      omCode: ''
    }
  },
  watch: {
    selectMethod(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateData(this.methodConfig[Math.floor(newValue / 3)][newValue % 3])
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'userInfo', 'methodConfig'])
  },
  mounted() {
    if (this.from == 'deposit') {
      this.selectChannel = Math.max(
        this.payChannels.findIndex((item) => {
          return item.value == this.userInfo.rechargeChannel
        }),
        0
      )
    } else if (this.from == 'withdraw') {
      this.selectChannel = Math.max(
        this.payChannels.findIndex((item) => {
          return item.value == this.userInfo.withdrawChannel
        }),
        0
      )
    }
    if (this.methodConfig.length > 0) {
      this.updateData(this.methodConfig[Math.floor(this.selectMethod / 3)][this.selectMethod % 3])
    }
  },

  methods: {
    onSelectMethod(index) {
      this.selectMethod = index
    }
  }
}
</script>

<style lang="scss" scoped>
.dw_con_ke {
  width: 94%;
  height: auto;
  padding: 3% 3% 3% 0;
  margin-bottom: -3%;
  // margin: 0 5% 2% 5%;
  // display: inline-block;
  // background: linear-gradient(-55deg, #6d7673, #3d3d3d, #2b2b2c, #4d4f4f);

  // background: #d6dce1;
  // border-radius: 0.16rem;

  .om_inputbox {
    line-height: 0.7rem;
    background-color: #fff;
    background-image: linear-gradient(#eeeeee, #fff 15%);
    display: inline-block;
    height: 0.7rem;
    width: 100%;
    border-radius: 0.1rem;
    font-size: 0.24rem;
    // margin: 0.1rem 0 0 0;
    // padding: 0 5% 0 5%;
    margin-bottom: 0.2rem;
    border: 1px solid #bec3c7;

    input {
      outline-style: none;
      outline-width: 0;
      border: none;
      border-style: none;
      text-shadow: none;
      -webkit-appearance: none;
      -webkit-user-select: text;
      outline-color: transparent;
      background-color: transparent;
      box-shadow: none;
      font-size: 0.24rem;
      line-height: 0.7rem;
      padding-left: 5%;
      width: 100%;
      color: #000;
    }

    input::placeholder {
      color: #95a5a5;
    }
  }
}

.dw_con_ke ul {
  width: 100%;
  height: auto;
  // padding: 0.3rem 0 0 0;
  margin: 0;
  // border-top-width: 1px;
  // border-bottom-width: 1px;
  // border-left-width: 1px;
  // border-top-style: solid;
  // border-bottom-style: solid;
  // border-top-color: #d9dee0;
  // border-bottom-color: #d9dee0;
}

.dw_title {
  height: auto;
  width: 100%;

  font-size: 0.24rem !important;
  color: #000;
  font-weight: normal;
  margin: 0 3%;
}

.dw_Pay {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  // align-items: center;
  // justify-content: flex-start;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  // overflow: hidden;

  .dw_row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 103%;

    .active {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      // float: left;
      padding: 0.05rem 0.05rem;
      width: 100%;
      height: 0.8rem;
      margin: 0.05rem 0.01rem;
      border-radius: 0.16rem;
      // display: inline-block;
      font-size: 0.24rem;
      color: #fff !important;
      background-color: #ceb45f;
      border: 0.02rem solid #ceb45f !important;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0.16rem;
      }
    }

    .un_active {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #778989;
      text-align: center;
      width: 100%;
      height: 0.8rem;
      padding: 0.05rem 0.05rem;
      margin: 0.05rem 0.01rem;
      border-radius: 0.16rem;
      border: 0.02rem solid rgba($color: #000000, $alpha: 0);
      font-size: 0.24rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0.16rem;
      }
    }
  }
}

.inputbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 0.7rem;
  background-color: #fff;
  background-image: linear-gradient(#eeeeee, #fff 15%);
  height: 0.7rem;
  width: 90%;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  margin: 0.2rem 0;
  padding: 0 5%;
  overflow: hidden;
  border: 1px solid #bec3c7;

  p {
    color: #000;
    display: inline;
  }
}

.selectRatio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 0.7rem;
  background-color: #fff;
  background-image: linear-gradient(#eeeeee, #fff 15%);
  height: auto;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  padding: 0 5%;
  overflow: hidden;
  border: 1px solid #bec3c7;
  margin-top: -0.2rem;
  position: absolute;
  width: 71%;

  li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 90%;
    margin: auto 5%;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #bec3c7;
    padding: 0;

    p {
      color: #000;
      display: inline;
      margin-left: 0.2rem;
    }
  }
}
</style>
